module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-center-content"
  }, [_c('h4', [_vm._v("任务管理")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("1.  如何发布任务？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("你需要通过发布海选任务来寻找主播。在【版权工作台】的【版权管理】中，你可以查看所上传版权内容的审核状态。审核通过的版权内容，就能够开始发布任务了。")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "577px",
      "border": "1px solid #eee"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "copyrightHelpCenter/img_6.jpeg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("发布任务时， 你需要填写任务基本信息、任务录制要求以及海选试音要求，确认提交后，即可成功发布任务。")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "597px",
      "border": "1px solid #eee"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "copyrightHelpCenter/img_7.jpeg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("海选任务发布后，你可以在【任务管理】中查看任务详情。在任务详情界面，你可以查看任务参选人数，以及收听不同主播的海选试音。")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "590px",
      "border": "1px solid #eee"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "copyrightHelpCenter/img_8.jpeg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("2.  任务发布后，我还要做些什么？")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("3.  如何设定主播酬劳？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("设定合理的酬劳有利于快速找到合适的主播，建议录制每集的酬劳在50元以上哦。")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v(" 海选任务发布后，你可以在【任务管理】中查看不同状态的任务。 在不同的任务阶段，你能够做不同的事情："), _c('br'), _vm._v("\n        海选中：查看参选情况，收听海选试音；"), _c('br'), _vm._v("\n        选拔中：挑选合适的主播，并和主播进行签约。"), _c('br'), _vm._v("\n        制作中： 主播会根据任务要求，录制音频并上架至专辑。你可以在制作中的任务，查看该  任务的录制主播、专辑以及录制声音进度。"), _c('br'), _vm._v("\n        已完结：当主播完成该任务录制，会申请任务完结。")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0018ac2c!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/helpCenter/HelpCenterTaskManagement.vue
// module id = 562
// module chunks = 0